document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".inc").forEach(function(element) {
        element.addEventListener('click', function() {
            document.querySelectorAll(".mfktog").forEach(function(el) {
                el.classList.remove("active");
            });
            document.querySelectorAll(".cms").forEach(function(el) {
                el.style.display = "none";
            });
            document.querySelectorAll(".inch").forEach(function(el) {
                el.style.display = "block";
            });
        });
    });

    document.querySelectorAll(".cmc").forEach(function(element) {
        element.addEventListener('click', function() {
            document.querySelectorAll(".mfktog").forEach(function(el) {
                el.classList.add("active");
            });
            document.querySelectorAll(".cms").forEach(function(el) {
                el.style.display = "block";
            });
            document.querySelectorAll(".inch").forEach(function(el) {
                el.style.display = "none";
            });
        });
    });

    document.querySelectorAll(".sc-button").forEach(function(element) {
        element.addEventListener('click', function() {
            document.getElementById("size-chart").style.display = "block";
            let sizeChartKing = document?.querySelector('.swatch-size-chart');
            sizeChartKing.classList.remove('swatch-size-chart');
        });
    });

    document.querySelectorAll(".closex").forEach(function(element) {
        element.addEventListener('click', function() {
            document.getElementById("size-chart").style.display = "none";
            let sizeChartKing = document?.querySelector('.swatch-king-size-chart');
            sizeChartKing.classList.add('swatch-size-chart');
        });
    });
});
